function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from 'react';

var _ref =
/*#__PURE__*/
React.createElement("path", {
  fill: "none",
  stroke: "currentColor",
  strokeWidth: 8191.52,
  strokeLinecap: "round",
  strokeLinejoin: "round",
  d: "M82334 11958l-28151 0c-5182,0 -9382,4202 -9382,9384l0 9382 46916 0 0 -9382c0,-5182 -4200,-9384 -9382,-9384zm-75065 18767l121983 0m-46918 65683l0 -37534m-28151 37534l0 -37534m46918 65685l-65683 0c-5182,0 -9384,-4200 -9384,-9382l0 -84452 84450 0 0 84452c0,5182 -4202,9382 -9382,9382z"
});

var SvgComponent = function SvgComponent(props) {
  return React.createElement("svg", _extends({
    viewBox: "0 0 136517 136517",
    className: "icon",
    style: {
      "height": "1em",
      "width": "1em"
    }
  }, props), _ref);
};

export default __webpack_public_path__ + "static/media/trash.9e1e275f.svg";
export { SvgComponent as ReactComponent };